import Vue from 'vue'
import Mutations from '../data/mutations'
export default {
  namespaced: true,
  state: {
    listView: true,
    contractor: "",
    driver: "",
    vehicleId: "",
    site: "",
    siteObj: {},
    notes: "",
    date: "",
    dateReceived: "",
    externalRef: "",
    billingPeriod: null,
    trips: [],
    dockets: [],
    docketRateId: "",
    loadingDockets: false,
    loadingTrips: false,
    selectedAllocation: {},
    creditData: null,
    adjustmentData: null,
    commitDocket: false
  },
  mutations: Mutations,
  actions: {
    resetForm(context) {
      context.commit('setState', { prop: 'contractor', value: '' })
      context.commit('setState', { prop: 'driver', value: '' })
      context.commit('setState', { prop: 'vehicle', value: '' })
      //context.commit('setState', { prop: 'site', value: '' })
      context.commit('setState', { prop: 'notes', value: '' })
      //context.commit('setState', { prop: 'date', value: '' })
      context.commit('setState', { prop: 'externalRef', value: '' })
      context.commit('setState', { prop: 'trips', value: [] })

    },
    resetFormFull(context) {
      context.commit('setState', { prop: 'site', value: '' })
      context.commit('setState', { prop: 'date', value: '' })
    }
  },
  getters: {
    getTrips: state => state.trips,
    getDockets: state => state.dockets
  }
}